import { Component, Inject, Input, OnChanges, OnInit, Optional, SimpleChanges } from '@angular/core';
import { SchedulerItemChange, SchedulerSlotSelected } from '@app/core/components/scheduler/scheduler.component';
import { RememberService } from '@app/core/services/remember.service';
import { UtilityService } from '@app/core/services/utility.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { GetTimeSheetDiaryParams, TimeSheetDiaryGet, TimeSheetDiaryService, TSDOwnerItem, TSDPortalUserItem, TSDTaskItem } from '@app/services/time-sheet-diary.service';

@Component({
    selector: 'tt-time-sheet-diary',
    templateUrl: './time-sheet-diary.component.html',
    styleUrls: ['./time-sheet-diary.component.css'],
})
export class TimeSheetDiaryComponent implements OnInit, OnChanges {
    @Input()
    public params?: GetTimeSheetDiaryParams;

    public get?: TimeSheetDiaryGet;

    public portalUsers: TSDPortalUserItem[] = [];

    public tasks: TSDTaskItem[] = [];

    public owners: TSDOwnerItem[] = [];

    constructor(
        private timeSheetDiary: TimeSheetDiaryService,
        private remember: RememberService,
        private utility: UtilityService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) {
        this.navigator = useNavigatorFor(navigator, this);
    }

    public async onSlotSelected(event: SchedulerSlotSelected) {
        await this.remember.remember('scheduler.datetimefrom', event.startDatestring);

        if (event.originalEvent && this.utility.isModifierKeyPressed(event.originalEvent as MouseEvent)) {
            this.navigator?.newTab({ to: 'timeregister', parms: '0/0' });
        } else {
            this.navigator?.go({ to: 'timeregister', parms: '0/0' });
        }
    }

    public async onEventChanged(event: SchedulerItemChange<TSDTaskItem>) {
        const error = !!(await this.timeSheetDiary.updateTask({ id: event.item.item_id, start: event.currentValue.startDatestring, end: event.currentValue.endDatestring }));

        if (error) {
            this.loadTasks();
        }
    }

    private async loadGet() {
        if (!!this.params) {
            this.get = await this.timeSheetDiary.getTimeSheetDiary(this.params);
        }
    }

    private async loadPortalUsers() {
        if (!!this.params) {
            this.portalUsers = await this.timeSheetDiary.getPortalUsers(this.params);
        }
    }

    public async loadTasks() {
        if (!!this.get) {
            this.tasks = await this.timeSheetDiary.getTasks(this.get);
        }
    }

    private async loadOwners() {
        if (!!this.get) {
            this.owners = await this.timeSheetDiary.getOwners(this.get);
        }
    }

    private async init() {
        this.loadPortalUsers();
        await this.loadGet();
        this.loadTasks();
        this.loadOwners();

        if (!!this.get?.page_heading) {
            this.navigator?.setHeading?.(this.get.page_heading);
        }
    }

    ngOnInit(): void {
        if (!!this.navigator) {
            this.navigator.setSize?.({ height: '95vh', width: '98vw' });
            this.params = this.navigator.params as any;
            this.init();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!!changes['params']) {
            this.init();
        }
    }
}
